import React, { useState, useEffect } from 'react'
import {
    Button,
    ButtonContainer,
    ButtonStatus,
    Container,
    ContentTask,
    DescriptionTask,
    ErrorMessage,
    FFile,
    FInput,
    FInputArea,
    FInputWrapper,
    Header,
    Icon,
    Image,
    ImageContainer,
    ModalContainer,
    ModalContent,
    OverlayLoading,
    Status,
    StatusContainer,
    Title,
    TitleTask
} from '../components/tambahTugas'
import { iconClose } from '../../../../assets'
import API from '../../../../config/api';
import swal from 'sweetalert';
import { Loading } from '../../../../components/atoms';

const ModalDetail = (props) => {
    const { openModal, handlCLose, data, getTicket, setData, setTypeModal } = props
    const token = localStorage.getItem('token')
    console.log('data', data)
    const onClose = () => {
        handlCLose()
        setTypeModal()
        setData(null)
    }
    const handleStatus = (datas) => {
        const payload = new FormData();
        payload.append('status', datas);
        API.editStatusTicket(token, data?.id, payload)
            .then(res => {
                getTicket()
                handlCLose()
                setTypeModal()
                setData(null)
            })
            .catch(err => {
                handlCLose()
            });
    }
    return (
        openModal && (
            <ModalContainer>
                <Container>
                    <ModalContent>
                        <Header>
                            <Title>Detail Tugas</Title>
                            <Icon src={iconClose} onClick={onClose} />
                        </Header>
                        <ContentTask>
                            <TitleTask>
                                {data?.title}
                            </TitleTask>
                            <DescriptionTask>
                                {data?.description}
                            </DescriptionTask>
                            {
                                data?.attachments?.map((image, index) => (
                                    <ImageContainer key={index}>
                                        <Image src={image?.url} alt={image?.url} />
                                    </ImageContainer>
                                ))
                            }
                            <StatusContainer>
                                <Status className={data?.status}>Status: {data?.status === "diproses" ? "Proses" : data?.status === "selesai" ? "Selesai" : "Baru"}</Status>
                                {
                                    data?.status != 'selesai' && <ButtonStatus className={data?.status} onClick={() => handleStatus(data?.status === "baru" ? "diproses" : data?.status === "diproses" && "selesai")}>{data?.status === "baru" ? "Proses" : data?.status === "diproses" && "Selesai"}</ButtonStatus>
                                }
                            </StatusContainer>
                        </ContentTask>
                    </ModalContent>
                </Container>
            </ModalContainer>
        )
    )
}

export default ModalDetail
